import React from 'react';
import { Link, Redirect, Route, Switch } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import PropTypes from 'prop-types';
import { selectHasAuthorized } from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import SignIn from '../../../../components/UserAccount/SignIn';
import SignUp from '../../../../components/UserAccount/SignUp';
import ForgetPassword from '../../../../components/UserAccount/ForgetPassword';
import ChangePassword from '../../../../components/UserAccount/ChangePassword';
import ListItemLink from '../../../../components/Common/ListItemLink/ListItemLink';
import ConfirmNewEmail from '../../../../components/UserAccount/Confirms/ConfirmNewEmail/ConfirmNewEmail';

const Account = props => (
  <div className="page-vertical-middle">
    <div className="page-wrapper">
      <div className="container">
        <div className="row">
          <div className="col-xs-24 col-sm-12 col-sm-offset-6 col-md-10 col-md-offset-7 col-lg-8 col-lg-offset-8">
            <div className="panel panel-default panel-shadow panel-login">
              <div className="tab-content">
                <div className="tab-pane active" id="sign">
                  <div className="panel-body">
                    <img
                      className="img-responsive center-block m-t-30"
                      alt=""
                      src="/img/logo.png"
                    />
                  </div>
                  <Switch>
                    <Route
                      exact
                      path="/account"
                      render={() => <Redirect to="/account/sign/in" />}
                    />
                    <Route
                      exact
                      path="/account/sign"
                      render={() => <Redirect to="/account/sign/in" />}
                    />
                    <Route
                      path="/account/sign"
                      render={() => (
                        <div>
                          <div className="panel-bar">
                            <ul className="nav nav-tabs nav-center">
                              <ListItemLink to={'/account/sign/in'}>
                                Вход в панель
                              </ListItemLink>
                              <ListItemLink to={'/account/sign/up'}>
                                Регистрация
                              </ListItemLink>
                            </ul>
                          </div>
                          <div className="panel-body">
                            <div className="tab-content">
                              <Switch>
                                <Route
                                  path="/account/sign/in"
                                  render={() => <SignIn />}
                                />
                                <Route
                                  path="/account/sign/up"
                                  render={() => <SignUp />}
                                />
                              </Switch>
                            </div>
                          </div>
                        </div>
                      )}
                    />
                    <Route
                      path="/account/sign/by-token"
                      render={() => (
                        <div>
                          <p />
                        </div>
                      )}
                    />
                    <Route
                      path="/account/reset-password"
                      render={() => (
                        <div className="panel-body">
                          <div className="tab-content">
                            <Switch>
                              <Route
                                path="/account/reset-password/request"
                                render={() => (
                                  <div>
                                    <h3 className="text-center m-t-5">
                                      Забыли пароль?
                                    </h3>
                                    <p className="text-center">
                                      Не переживайте. Просто введите свою эл.
                                      почту, и мы вышлем инструкцию по
                                      восстановлению.
                                    </p>
                                    <ForgetPassword />
                                    <p className="m-t-15 m-b-0 text-center">
                                      {props.hasAuthorized ? (
                                        <Link to={'/'}>
                                          <i
                                            className="fa fa-arrow-circle-left"
                                            aria-hidden="true"
                                          />{' '}
                                          Вернуться на главную
                                        </Link>
                                      ) : (
                                        <Link to={'/account/sign/in'}>
                                          <i
                                            className="fa fa-arrow-circle-left"
                                            aria-hidden="true"
                                          />{' '}
                                          Назад к форме входа
                                        </Link>
                                      )}
                                    </p>
                                  </div>
                                )}
                              />
                              <Route
                                path="/account/reset-password/to-change"
                                render={() => (
                                  <div>
                                    <ChangePassword />
                                    <p className="m-t-15 m-b-0 text-center">
                                      {props.hasAuthorized ? (
                                        <Link to={'/'}>
                                          <i
                                            className="fa fa-arrow-circle-left"
                                            aria-hidden="true"
                                          />{' '}
                                          Вернуться на главную
                                        </Link>
                                      ) : (
                                        <Link to={'/account/sign/in'}>
                                          <i
                                            className="fa fa-arrow-circle-left"
                                            aria-hidden="true"
                                          />{' '}
                                          Назад к форме входа
                                        </Link>
                                      )}
                                    </p>
                                  </div>
                                )}
                              />
                            </Switch>
                          </div>
                        </div>
                      )}
                    />
                    <Route
                      path="/account/confirm"
                      render={() => (
                        <div className="panel-body">
                          <div className="tab-content">
                            <Switch>
                              <Route
                                path="/account/confirm/new-email"
                                render={() => <ConfirmNewEmail />}
                              />
                              <Route
                                path="/account/confirm/change-email"
                                render={() => <ChangePassword />}
                              />
                            </Switch>
                          </div>
                        </div>
                      )}
                    />
                  </Switch>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

Account.defaultProps = {
  hasAuthorized: null
};

Account.propTypes = {
  hasAuthorized: PropTypes.bool
};

const mapStateToProps = state => ({
  hasAuthorized: selectHasAuthorized(state)
});

export default connect(mapStateToProps)(Account);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/Account/Account.js